import { GlobalStatus, ProductionTypeEnum } from "@gtpl/shared-models/common-models";
import { SaleOrderDto } from "@gtpl/shared-models/sale-management";
import { ApiProperty } from "@nestjs/swagger";
import { SaleOrder } from "libs/shared-models/sale-management/src/lib/sale-order/dto/so-details.dto";

export class SoProductionDTO{

    @ApiProperty() 
    soProductionId: number;
    @ApiProperty()
    type: ProductionTypeEnum;
    @ApiProperty()
    lotNumber: string;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    inputQuantity: number;
    @ApiProperty()
    outputQuantity: number;
    @ApiProperty()
    createdAt?: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt?: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    versionFlag?: number;
    
    
}